const Login = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/login/Login.vue')
const xyIndex = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/xy/XyIndex.vue')
const xyParent = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/xy/XyParent.vue')
const messageList = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/message/messageList.vue')
const messageDetail = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/message/messageDetail.vue')
const ChangePassword = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/changePassword/ChangePassword.vue')
const Funclist = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/funclist/FuncList.vue')
const Error401 = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/error/Error401.vue')
const Error404 = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/error/Error404.vue')
// 家长首页底部功能
const home = () => import( /* webpackChunkName: "common" */ '@/pages/common/views/xy/parent/Home.vue')
const letter = () => import( /* webpackChunkName: "common" */ '@/pages/common/views/xy/parent/Letter.vue')
const classTable = () => import( /* webpackChunkName: "common" */ '@/pages/common/views/xy/parent/ClassTable.vue')
const center = () => import( /* webpackChunkName: "common" */ '@/pages/common/views/xy/parent/Center.vue')

// 访客
const VisitLogin = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/login/VisitLogin.vue')
// 访客login
const VistorLogin = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/login/loginVisit.vue')

const common = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/error401',
    name: 'error401',
    component: Error401
  },
  {
    path: '/error404',
    name: 'error404',
    component: Error404
  },
  {
    path: '/visitLogin',
    name: 'VisitLogin',
    component: VisitLogin
  },
  {
    path: '/vistorLogin',
    name: 'VistorLogin',
    component: VistorLogin
  },
  {
    path: '/xyIndex',
    name: 'xyIndex',
    component: xyIndex
  },
  {
    path: '/xyParent',
    name: 'xyParent',
    component: xyParent,
    children: [
      {
        path: 'home',
        name: 'home',
        component: home
      },
      {
        path: 'letter',
        name: 'letter',
        component: letter
      },
      {
        path: 'classTable',
        name: 'classTable',
        component: classTable
      },
      {
        path: 'center',
        name: 'center',
        component: center
      }
    ]
  },
  {
    path: '/messageList',
    name: 'messageList',
    component: messageList
  },
  {
    path: '/messageDetail',
    name: 'messageDetail',
    component: messageDetail
  },
  {
    path: '/password',
    name: 'changePassword',
    component: ChangePassword
  },
  {
    path: '/funclist',
    name: 'funclist',
    component: Funclist
  },
]
export default common



